<template>
  <div class="setting-display-table">
    <button
      @click="$bvModal.show('Cai-dat-hien-thi')"
      class="font-medium f12 btn btn-outline-secondary"
    >
      Cài đặt hiển thị
    </button>
    <b-modal
      centered
      no-close-on-esc
      no-close-on-backdrop
      static
      id="Cai-dat-hien-thi"
      size="small"
    >
      <template #modal-header>
        <h5>Cài đặt hiển thị</h5>
        <b-button size="sm" variant="light" @click="closePopup"> x </b-button>
      </template>

      <draggable @change="disabled = false" v-model="modelValue" class="draggable-wrapper">
        <div
          v-for="el in modelValue"
          :key="el.key"
          :class="canShow(el.key) ? 'draggable-item' : 'd-none'"
        >
          <template v-if="canShow(el.key)">
            <b-checkbox @change="disabled = false" v-model="el.show" :disabled="el.disabled"
              ><p type="button">{{ el.label }}</p></b-checkbox
            >
            <span type="button">
              <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style="cursor: pointer"
                @click="$bvModal.show('Cai-dat-hien-thi')"
              >
                <path
                  d="M6.16016 9.50391C6.85449 9.50391 7.4082 8.9502 7.4082 8.25586C7.4082 7.57031 6.85449 7.00781 6.16016 7.00781C5.47461 7.00781 4.91211 7.57031 4.91211 8.25586C4.91211 8.9502 5.47461 9.50391 6.16016 9.50391ZM10.291 9.09961H22.2266C22.7012 9.09961 23.0791 8.73047 23.0791 8.25586C23.0791 7.78125 22.71 7.41211 22.2266 7.41211H10.291C9.8252 7.41211 9.44727 7.78125 9.44727 8.25586C9.44727 8.73047 9.81641 9.09961 10.291 9.09961ZM6.16016 14.9092C6.85449 14.9092 7.4082 14.3555 7.4082 13.6611C7.4082 12.9756 6.85449 12.4131 6.16016 12.4131C5.47461 12.4131 4.91211 12.9756 4.91211 13.6611C4.91211 14.3555 5.47461 14.9092 6.16016 14.9092ZM10.291 14.5049H22.2266C22.7012 14.5049 23.0791 14.1357 23.0791 13.6611C23.0791 13.1865 22.71 12.8174 22.2266 12.8174H10.291C9.8252 12.8174 9.44727 13.1865 9.44727 13.6611C9.44727 14.1357 9.81641 14.5049 10.291 14.5049ZM6.16016 20.3145C6.85449 20.3145 7.4082 19.7607 7.4082 19.0664C7.4082 18.3809 6.85449 17.8184 6.16016 17.8184C5.47461 17.8184 4.91211 18.3809 4.91211 19.0664C4.91211 19.7607 5.47461 20.3145 6.16016 20.3145ZM10.291 19.9102H22.2266C22.7012 19.9102 23.0791 19.541 23.0791 19.0664C23.0791 18.5918 22.71 18.2227 22.2266 18.2227H10.291C9.8252 18.2227 9.44727 18.5918 9.44727 19.0664C9.44727 19.541 9.81641 19.9102 10.291 19.9102Z"
                  fill="#888888"
                />
              </svg>
            </span>
          </template>
        </div>
      </draggable>

      <template #modal-footer>
        <b-button variant="light" @click="closePopup"> Đóng </b-button>
        <b-button variant="primary" :disabled="disabled" @click="submit()"> Hoàn tất </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import sortBy from 'lodash/sortBy'
  import Cookies from 'js-cookie'
  import draggable from 'vuedraggable'
  export default {
    components: {
      draggable,
    },
    props: {
      fields: {
        type: Array,
        default: () => [],
      },
      noDragItem: {
        type: Array,
        default: () => ['action', 'selected', 'index'],
      },
      naming: {
        type: String,
        default: null,
      },
    },

    model: {
      prop: 'fields',
      event: 'value',
    },
    data() {
      return {
        baseData: [],
        modelValue: [],
        disabled: true,
      }
    },
    methods: {
      canShow(val) {
        return !this.noDragItem.includes(val)
      },
      closePopup() {
        this.$bvModal.hide('Cai-dat-hien-thi')
        this.modelValue = this.baseData.map(e => e)
        this.disabled = true
      },
      submit() {
        this.$bvModal.hide('Cai-dat-hien-thi')
        this.$emit(
          'change',
          this.modelValue.filter(s => s.show)
        )
        this.$emit('value', this.modelValue)

        if (this.naming) {
          console.log('config dgtb', this.naming)
          Cookies.set(
            this.naming,
            JSON.stringify(
              this.modelValue.map(s => {
                const data = {
                  k: s.key,
                }
                if (s.fixIndex) data.i = s.fixIndex
                if (s.show === false) data.s = 0
                if (s.disabled === true) data.d = 1
                return data
              })
            )
          )
        }
        this.disabled = true
      },
      leftJoin(arrs, stores, arrKey, storeKey) {
        const storesT = stores.map((s, index) => {
          return {
            key: s.k,
            index: s.i ?? index,
            show: s.s !== 0,
            disabled: s.d === 1,
          }
        })
        return sortBy(
          arrs.map(arr => {
            const data = {
              ...arr,
              ...storesT.find(store => arr[arrKey] === store[storeKey]),
            }
            if (arr.fixIndex) data.index = arr.fixIndex
            return data
          }),
          ['index']
        )
      },
      fetchData(val) {
        let data = val.map(s => {
          return {
            ...s,
            show: s.show ?? true,
            disabled: s.disabled ?? false,
            index: 99,
          }
        })
        if (this.naming) {
          const storagaData = Cookies.get(this.naming)
          if (storagaData) {
            data = this.leftJoin(data, JSON.parse(storagaData), 'key', 'key')
          }
        }
        this.baseData = data
        this.modelValue = data
        this.$emit(
          'change',
          this.modelValue.filter(s => s.show)
        )
      },
    },
    created() {
      if (this.fields) {
        this.fetchData(this.fields)
      }
    },
  }
</script>

<style lang="scss">
  .setting-display-table {
    button {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    display: inline;
    #Cai-dat-hien-thi___BV_modal_outer_ {
      z-index: 1200 !important;
    }
    .modal-body {
      .draggable-wrapper {
        overflow-y: auto;
        max-height: 65vh;
        border: 1px solid rgba(0, 0, 0, 0.07);
        border-bottom: none;
        border-radius: 0.25rem;
        .draggable-item {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.75rem 1.25rem;
          background-color: #fff;
          border-bottom: 1px solid rgba(0, 0, 0, 0.07);
          p {
            line-height: 25px;
          }
        }
      }
    }
  }
</style>
